<agr-page-toolbar
  [pageTitle]="pageTitle()"
  [isEmpty]="emptyContactpersons$ | async"
  emptyTitle="{{ 'app.no_results_title' | translate }}"
  emptyDescription="{{ 'app.no_results_description' | translate }}"
  [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
>
  <ng-container actions>
    <app-search-field
      [value]="searchTextValue$ | async"
      [placeholderText]="'app.contactperson.search.placeholder' | translate"
      [isLoading$]="isLoading$"
      (searchValueChanged)="searchValueChanged($event)"
      class="search-contactperson"
    ></app-search-field>
    <agr-primary-action
      actionIcon="add"
      [actionText]="'add' | translate"
      (action)="add()"
      data-test="contactperson__add"
    ></agr-primary-action>
  </ng-container>

  <agr-table-v2 [dataSource]="contactpersonsDataSource" [withSelection]="false">
    <ng-container *agrTableFiltersWrapper></ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{ 'app.contactperson.contactperson' | translate }}</th>
      <td mat-cell *matCellDef="let contactperson" data-test="contactperson-overview-item__name">
        <div class="overview-table__primary">{{ getName(contactperson) }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.contactperson.detail.title_address' | translate }}
      </th>
      <td mat-cell *matCellDef="let contactperson" data-test="contactperson-overview-item__address">
        <div>{{ getAddress(contactperson) }}</div>
        <div class="text--gray">
          {{ getCity(contactperson) }}
          @if (contactperson.country) {
            <span>{{ 'app.countries.' + contactperson.country | translate }}</span>
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.contactperson.detail.email_address' | translate }}
      </th>
      <td mat-cell *matCellDef="let contactperson" data-test="contactperson-overview-item__email">
        {{ contactperson.emailAddress }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="overview-table__row"
      data-test="contactperson-overview__item"
      tabindex="0"
      (click)="openContactperson(row)"
      (keydown.enter)="openContactperson(row)"
    ></tr>
    <tr *matNoDataRow>
      <td class="text--center" [attr.colspan]="displayedColumns.length">
        <agr-notification-empty
          [isEmpty]="true"
          emptyTitle="{{ 'app.no_results_title' | translate }}"
          emptyDescription="{{ 'app.no_results_description' | translate }}"
          [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
        ></agr-notification-empty>
      </td>
    </tr>
  </agr-table-v2>
</agr-page-toolbar>
